<mat-toolbar
  color="primary"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  Transfer asset
</mat-toolbar>
<div class="basic-container">
  <form [formGroup]="form" (submit)="initiate()">
    <div id="content" fxLayout="column" fxLayoutGap="16px">
      <h3>
        Please enter the required information to transfer your asset
      </h3>

      <!-- Basic Transfer Info -->
      <div
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutWrap
        fxLayoutGap="3.5%"
        fxLayoutAlign="left"
      >
        <mat-form-field class="example-full-width" [appearance]="'fill'" style="padding-top: 5.5px;">
          <mat-label>Receiver Address</mat-label>
          <input matInput placeholder="e.g. 0xdCDFc6A8D4DC39A26fB63dc409f20b20107d7a1F" formControlName="to" />
        </mat-form-field>
        <mat-form-field class="example-full-width" [appearance]="'fill'" style="padding-top: 5.5px;">
          <mat-label>Amount</mat-label>
          <input matInput type="number" placeholder="Transfer amount" formControlName="amount" />
        </mat-form-field>
      </div>

      <!-- Spending Conditions Panel -->
      <mat-expansion-panel *ngIf="this.isZeroToken">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Spending Conditions
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Add Policy Layer Button -->
        <div style="margin-bottom: 1.5em">
          <button mat-raised-button color="primary" type="button" (click)="addPolicyLayer()">
            <mat-icon>add_box</mat-icon>
            Add Policy Layer
          </button>
          <span class="hint-text" style="margin-left: 1em; color: gray;">
            Each policy layer applies to one transaction in the chain
          </span>
        </div>

        <!-- Policy Layers -->
        <div *ngFor="let policy of policies; let policyIndex = index" style="margin-bottom: 2em;">
          <mat-card>
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>
                  Policy Layer {{ policyIndex + 1 }}
                  <span *ngIf="policyIndex < policies.length - 1" style="color: gray; font-size: 0.8em;">
                    → chains to Layer {{ policyIndex + 2 }}
                  </span>
                  <span *ngIf="policyIndex === policies.length - 1 && !policy.permanent" style="color: green; font-size: 0.8em;">
                    → releases to unrestricted
                  </span>
                  <span *ngIf="policy.permanent" style="color: orange; font-size: 0.8em;">
                    → permanent (persists forever)
                  </span>
                </mat-card-title>
              </mat-card-title-group>
              <button mat-icon-button color="warn" type="button" (click)="removePolicyLayer(policyIndex)" matTooltip="Remove Policy Layer">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>

            <mat-card-content>
              <!-- Policy Metadata -->
              <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" style="margin-bottom: 1em;">
                <mat-form-field [appearance]="'outline'" fxFlex>
                  <mat-label>Policy Name</mat-label>
                  <input matInput placeholder="e.g. Education Grant - Eligibility"
                         [(ngModel)]="policy.name" [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
                <mat-form-field [appearance]="'outline'" fxFlex>
                  <mat-label>Description</mat-label>
                  <input matInput placeholder="e.g. Recipient must prove student status"
                         [(ngModel)]="policy.description" [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
              </div>

              <!-- Trusted Issuers -->
              <div style="margin-bottom: 1em;">
                <mat-form-field [appearance]="'outline'" style="width: 100%;">
                  <mat-label>Trusted Issuers (DIDs)</mat-label>
                  <mat-chip-grid #issuerChipGrid>
                    <mat-chip-row *ngFor="let issuer of policy.trustedIssuers; let i = index"
                                  (removed)="removeIssuer(policyIndex, i)">
                      {{ issuer }}
                      <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip-row>
                    <input placeholder="Add issuer DID..."
                           [matChipInputFor]="issuerChipGrid"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                           (matChipInputTokenEnd)="addIssuer(policyIndex, $event)" />
                  </mat-chip-grid>
                  <mat-hint>e.g. did:web:university.edu (press Enter to add)</mat-hint>
                </mat-form-field>
              </div>

              <!-- Permanent Toggle (only for last layer) -->
              <div *ngIf="policyIndex === policies.length - 1" style="margin-bottom: 1em;">
                <mat-slide-toggle [(ngModel)]="policy.permanent" [ngModelOptions]="{standalone: true}"
                                  color="warn">
                  Permanent Policy (tokens stay bound to this policy forever)
                </mat-slide-toggle>
              </div>

              <!-- Group Composition -->
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-bottom: 1em;">
                <span><strong>Group Composition:</strong></span>
                <mat-button-toggle-group [(ngModel)]="policy.groupComposition" [ngModelOptions]="{standalone: true}">
                  <mat-button-toggle value="ALL">ALL (every group must pass)</mat-button-toggle>
                  <mat-button-toggle value="ANY">ANY (at least one group must pass)</mat-button-toggle>
                </mat-button-toggle-group>
                <button mat-stroked-button color="primary" type="button" (click)="addConditionGroup(policyIndex)">
                  <mat-icon>add</mat-icon>
                  Add Condition Group
                </button>
              </div>

              <!-- Condition Groups -->
              <div *ngIf="policy.groups.length === 0" style="padding: 1em; background: #f5f5f5; border-radius: 4px;">
                <p style="margin: 0; color: gray;">No condition groups added. Click "Add Condition Group" to define conditions.</p>
              </div>

              <div *ngFor="let group of policy.groups; let groupIndex = index" style="margin-bottom: 1em;">
                <mat-card style="background: #fafafa;">
                  <mat-card-header>
                    <mat-card-title style="font-size: 1em;">
                      Group {{ groupIndex + 1 }}
                    </mat-card-title>
                    <span fxFlex></span>
                    <mat-button-toggle-group [(ngModel)]="group.composition" [ngModelOptions]="{standalone: true}" style="margin-right: 1em;">
                      <mat-button-toggle value="ALL">ALL</mat-button-toggle>
                      <mat-button-toggle value="ANY">ANY</mat-button-toggle>
                    </mat-button-toggle-group>
                    <button mat-icon-button color="warn" type="button" (click)="removeConditionGroup(policyIndex, groupIndex)" matTooltip="Remove Group">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-card-header>

                  <mat-card-content>
                    <!-- Group Description -->
                    <mat-form-field [appearance]="'outline'" style="width: 100%; margin-bottom: 0.5em;">
                      <mat-label>Group Description (optional)</mat-label>
                      <input matInput placeholder="e.g. Geographic eligibility"
                             [(ngModel)]="group.description" [ngModelOptions]="{standalone: true}" />
                    </mat-form-field>

                    <!-- Add Condition Form -->
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutGap="8px"
                         style="margin-bottom: 1em; padding: 0.5em; background: #fff; border-radius: 4px;">
                      <mat-form-field [appearance]="'fill'" fxFlex="12">
                        <mat-label>Subject</mat-label>
                        <mat-select [(ngModel)]="newCondition[policyIndex][groupIndex].subject" [ngModelOptions]="{standalone: true}">
                          <mat-option *ngFor="let sub of subjects" [value]="sub">{{ sub }}</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field [appearance]="'fill'" fxFlex="15">
                        <mat-label>Attribute Name</mat-label>
                        <input matInput placeholder="e.g. age"
                               [(ngModel)]="newCondition[policyIndex][groupIndex].name" [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>

                      <mat-form-field [appearance]="'fill'" fxFlex="15">
                        <mat-label>Predicate</mat-label>
                        <mat-select [(ngModel)]="newCondition[policyIndex][groupIndex].predicate" [ngModelOptions]="{standalone: true}">
                          <mat-option *ngFor="let pred of predicates" [value]="pred.value">{{ pred.view }}</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- Value input - changes based on predicate -->
                      <ng-container *ngIf="!isArrayPredicate(newCondition[policyIndex][groupIndex].predicate)">
                        <mat-form-field [appearance]="'fill'" fxFlex="15">
                          <mat-label>Value</mat-label>
                          <input matInput placeholder="e.g. 18"
                                 [(ngModel)]="newCondition[policyIndex][groupIndex].value" [ngModelOptions]="{standalone: true}" />
                        </mat-form-field>
                      </ng-container>

                      <ng-container *ngIf="isArrayPredicate(newCondition[policyIndex][groupIndex].predicate)">
                        <mat-form-field [appearance]="'fill'" fxFlex="20">
                          <mat-label>Values (comma-separated)</mat-label>
                          <input matInput placeholder="e.g. DE, AT, CH"
                                 [(ngModel)]="newCondition[policyIndex][groupIndex].valueString" [ngModelOptions]="{standalone: true}" />
                          <mat-hint>Enter values separated by commas</mat-hint>
                        </mat-form-field>
                      </ng-container>

                      <!-- Optional: Per-condition issuers -->
                      <mat-form-field [appearance]="'fill'" fxFlex="20">
                        <mat-label>Issuers (optional, comma-sep)</mat-label>
                        <input matInput placeholder="e.g. did:web:gov.de"
                               [(ngModel)]="newCondition[policyIndex][groupIndex].issuersString" [ngModelOptions]="{standalone: true}" />
                        <mat-hint>Override policy-level issuers</mat-hint>
                      </mat-form-field>

                      <button mat-mini-fab color="primary" type="button"
                              (click)="addCondition(policyIndex, groupIndex)"
                              [disabled]="!canAddCondition(policyIndex, groupIndex)"
                              matTooltip="Add Condition">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>

                    <!-- Conditions Table -->
                    <div *ngIf="group.conditions.length === 0" style="padding: 0.5em; color: gray;">
                      No conditions in this group yet.
                    </div>

                    <table mat-table [dataSource]="group.conditions" class="mat-elevation-z2"
                           *ngIf="group.conditions.length > 0" style="width: 100%;">
                      <ng-container matColumnDef="subject">
                        <th mat-header-cell *matHeaderCellDef>Subject</th>
                        <td mat-cell *matCellDef="let condition">{{ condition.subject }}</td>
                      </ng-container>
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Attribute</th>
                        <td mat-cell *matCellDef="let condition">{{ condition.name }}</td>
                      </ng-container>
                      <ng-container matColumnDef="predicate">
                        <th mat-header-cell *matHeaderCellDef>Predicate</th>
                        <td mat-cell *matCellDef="let condition">{{ getPredicateView(condition.predicate) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef>Value</th>
                        <td mat-cell *matCellDef="let condition">{{ formatValue(condition.value) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="issuers">
                        <th mat-header-cell *matHeaderCellDef>Issuers</th>
                        <td mat-cell *matCellDef="let condition">
                          <span *ngIf="condition.issuers && condition.issuers.length > 0">
                            {{ condition.issuers.join(', ') }}
                          </span>
                          <span *ngIf="!condition.issuers || condition.issuers.length === 0" style="color: gray;">
                            (policy default)
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let condition; let condIndex = index">
                          <button mat-icon-button color="warn" type="button"
                                  (click)="removeCondition(policyIndex, groupIndex, condIndex)"
                                  matTooltip="Remove Condition">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="conditionDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: conditionDisplayedColumns;"></tr>
                    </table>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-expansion-panel>

      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Transfer</button>
      <button mat-button type="button" (click)="cancel()">Cancel</button>
    </div>
  </form>
</div>
